import { ParticipantState } from '../types';

type Options = {
    participants: string[];
    showMyVideo: boolean;
    maxDisplayParticipants: number;
    participantsByIds: Partial<Record<string, ParticipantState>>;
};
/**
 * Возвращает массив id участников отсортированных по следующей логике:
 * - на первой странице остаётся всё как есть
 * - на следующих страницах порядок следующий:
 *      - сначала те, кто с вкл видео и вкл микрофоном
 *      - потом те, кто с вкл видео, но выкл микрофоном
 *      - потом те, кто с выкл видео и вкл микрофоном
 *      - потом те, кто с выкл видео и выкл микрофоном
 *
 * @param {ConferenceState} state
 * @param {boolean} showMyVideo
 *
 * @returns {ParticipantID[]}
 */
export const sortParticipantsByDevices = ({
    participants,
    showMyVideo,
    maxDisplayParticipants,
    participantsByIds,
}: Options) => {
    const participantsOnFirstPage = maxDisplayParticipants + (showMyVideo ? 0 : 1);
    const otherParticipants = participants.slice(participantsOnFirstPage);
    otherParticipants.sort((id1, id2) => {
        const p1 = participantsByIds[id1];
        const p2 = participantsByIds[id2];

        const state1 = [p1?.video?.muted ?? true, p1?.audio?.muted ?? true, -(p1?.lastDominantTimestamp || 0), id1];
        const state2 = [p2?.video?.muted ?? true, p2?.audio?.muted ?? true, -(p2?.lastDominantTimestamp || 0), id2];

        for (let i = 0; i < state1.length; i++) {
            if (state1[i] < state2[i]) {
                return -1;
            } else if (state1[i] > state2[i]) {
                return 1;
            }
        }

        return 0;
    });
    return [...participants.slice(0, participantsOnFirstPage), ...otherParticipants];
};
